export class QuotationsContants {
	public static readonly MAX_PERIOD = 60
}
